module.exports = __webpack_public_path__ + "media/hph-25-02_impact.8320d630.webm";